var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "generic-route" }, [
    _c("div", { staticClass: "overlay" }),
    _c(
      "div",
      { staticClass: "wrapper" },
      [
        _c(
          "el-card",
          { staticClass: "login-card" },
          [
            _c("div", { staticClass: "login-logo" }, [
              _c("img", {
                attrs: {
                  src: require("@/assets/images/logo.svg"),
                  alt: "logflows",
                },
              }),
            ]),
            _c(
              "el-row",
              { staticClass: "login", attrs: { type: "flex" } },
              [
                _c(
                  "el-col",
                  { staticClass: "login-container" },
                  [
                    _vm.otpState.isOtpStep
                      ? _c("login-otp-form", {
                          ref: "otpForm",
                          attrs: {
                            "is-loading": _vm.otpState.isLoading,
                            "is-sent": _vm.otpState.isSent,
                            "resend-countdown": _vm.otpState.resendCountdown,
                          },
                          on: {
                            submit: _vm.verifyOtp,
                            resend: _vm.resendOtp,
                            cancel: _vm.cancelOtp,
                          },
                        })
                      : _c(
                          "el-form",
                          { attrs: { size: "large" } },
                          [
                            _c(
                              "el-row",
                              { attrs: { type: "flex" } },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 24 } },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        type: "text",
                                        id: "username",
                                        name: "username",
                                        placeholder: _vm.$t(
                                          "login.placeholder.username"
                                        ),
                                      },
                                      nativeOn: {
                                        keyup: function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          $event.preventDefault()
                                          return _vm.submitLogin.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.formData.username,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "username",
                                            $$v
                                          )
                                        },
                                        expression: "formData.username",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  { staticClass: "mt-3", attrs: { span: 24 } },
                                  [
                                    _c(
                                      "el-input",
                                      {
                                        attrs: {
                                          type: _vm.passwordType,
                                          id: "password",
                                          name: "password",
                                          placeholder: _vm.$t(
                                            "login.placeholder.password"
                                          ),
                                        },
                                        nativeOn: {
                                          keyup: function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            ) {
                                              return null
                                            }
                                            $event.preventDefault()
                                            return _vm.submitLogin.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                        model: {
                                          value: _vm.formData.password,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "password",
                                              $$v
                                            )
                                          },
                                          expression: "formData.password",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { slot: "append" },
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                return _vm.showPwd.apply(
                                                  null,
                                                  arguments
                                                )
                                              },
                                            },
                                            slot: "append",
                                          },
                                          [
                                            _vm.passwordType === "password"
                                              ? _c("font-awesome-icon", {
                                                  attrs: {
                                                    icon: ["far", "eye-slash"],
                                                    size: "lg",
                                                  },
                                                })
                                              : _c("font-awesome-icon", {
                                                  attrs: {
                                                    icon: ["far", "eye"],
                                                    size: "lg",
                                                  },
                                                }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  { staticClass: "mt-3", attrs: { span: 24 } },
                                  [
                                    _c("turnstile", {
                                      ref: "turnstile",
                                      on: {
                                        verify: _vm.onTurnstileVerify,
                                        expire: _vm.onTurnstileExpire,
                                        error: _vm.onTurnstileError,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  { staticClass: "mt-3", attrs: { span: 24 } },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "w-100 mt-3",
                                        attrs: {
                                          type: "primary",
                                          loading: _vm.otpState.isLoading,
                                        },
                                        nativeOn: {
                                          keyup: function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            ) {
                                              return null
                                            }
                                            $event.preventDefault()
                                            return _vm.submitLogin.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.submitLogin.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("login.logIn")) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  { staticClass: "mt-4", attrs: { span: 12 } },
                                  [
                                    _c(
                                      "el-checkbox",
                                      {
                                        model: {
                                          value: _vm.formData.rememberMe,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "rememberMe",
                                              $$v
                                            )
                                          },
                                          expression: "formData.rememberMe",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("login.rememberMe"))
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "mt-4 text-right",
                                    attrs: { span: 12 },
                                  },
                                  [
                                    _c(
                                      "el-checkbox",
                                      {
                                        staticStyle: {
                                          "text-transform": "uppercase",
                                        },
                                        model: {
                                          value: _vm.formData.isLogflows,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "isLogflows",
                                              $$v
                                            )
                                          },
                                          expression: "formData.isLogflows",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("login.isLogflowsUser"))
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }